export const Cookie = {
  getLocalCookie() {
    let localCookie = document.cookie
      .split(';')
      .map((v) => v.split('='))
      .reduce((acc, v) => {
        if (v[1] && v[1]?.trim())
          acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim())
        return acc
      }, {})

    if (localCookie.resource_bypass != null) {
      localCookie.resource = localCookie.resource_bypass
    }

    return localCookie
  },

  setLocalCookie(key, value, expiration, path) {
    let domain = window.location.host.replace(/^[^.]+\./, '.')
    domain = domain?.split(':')[0]
    document.cookie = `${key}=${value}; expires=${expiration}; path=${path}; domain=${domain}`
  },
  getMainDomain(url) {
    try {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = `https://${url}`
      }
      url = new URL(url).hostname
    } catch (e) {
      console.error(e)
    }
    let domain = url.replace(/^[^.]+\./, '.')
    domain = domain?.split(':')[0]
    return domain
  },
  getSubdomain(url) {
    try {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = `https://${url}`
      }
      url = new URL(url).hostname
    } catch (e) {
      console.error(e)
    }
    let main_domain = url.replace(/^[^.]+\./, '.')
    const sub_domain = url.replace(main_domain, '')
    return sub_domain.length == 0 ? main_domain : sub_domain
  }
}
